import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import gql from "graphql-tag";
import styled from "@emotion/styled";
import { useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { LoadingPage } from "../UI";
import { BumperHeader } from "../UI/Placeholder";
import { MaxWidth } from "../UI/Containers";
import { Link } from "react-router-dom";
import DateDisplay from "../UI/Date";

const SearchResult = ({ post }) => {
  const slug = post.category ? "/fastighet/" : "/nyheter/";
  return (
    <SearchResultWrapper>
      <h3>
        <Link to={slug + post.slug}>{post.title}</Link>
      </h3>
      {post.category && post.category}
      {post.time && <DateDisplay timestamp={post.time.timestamp} />}
    </SearchResultWrapper>
  );
};

const SearchContent = ({ results, searchTerm }) => {
  if (!results || results.length === 0) {
    return <p>Inga resultat hittades för "{searchTerm}".</p>;
  }
  return (
    <ResultList>
      {results.map((e, i) => {
        return <SearchResult key={i} post={e.node} />;
      })}
    </ResultList>
  );
};

const SearchResultWrapper = styled("div")`
  margin-bottom: 1rem;
`;

const ResultList = styled(MaxWidth)`
  max-width: 800px;
  text-align: left;

  ${(props) => props.theme.bp.below.md} {
    width: 100vw;
    padding: 0 5vw;
  }
`;

const ResultWrapper = styled("div")`
  padding: 1rem 0;
  text-align: center;
  background: #f7f7f7;
`;

const SearchPage = () => {
  const { searchTerm } = useParams();

  const { loading: propLoading, error: propError, data: propData } = useQuery(propertyQuery, {
    variables: { searchTerm },
  });
  const { loading: postLoading, error: postError, data: postData } = useQuery(postQuery, {
    variables: { searchTerm },
  });

  const loading = propLoading || postLoading;
  const error = propError || postError;
  let combinedResults = [];
  if (!loading && !error) {
    const propEdges = propData?.propertySearch?.edges || [];
    const postEdges = postData?.postSearch?.edges || [];
    combinedResults = [...propEdges, ...postEdges];
  }

  return (
    <Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Sökresultat för "{searchTerm}"</title>
      </Helmet>
      <BumperHeader />

      <ResultWrapper>
        <h1>Sökresultat för "{searchTerm}"</h1>
        {loading && <LoadingPage/>}
        {error && <p>Error loading search results.</p>}
        {!loading && !error && (
          <SearchContent results={combinedResults} searchTerm={searchTerm} />
        )}
      </ResultWrapper>
    </Fragment>
  );
};

const propertyQuery = gql`
  query PropertySearch($searchTerm: String) {
    propertySearch(searchTerm: $searchTerm) {
      edges {
        node {
          category
          title
          slug
          content
          website
          image(version: "business_box") {
            url
          }
        }
      }
    }
  }
`;

const postQuery = gql`
  query PostSearch($searchTerm: String) {
    postSearch(searchTerm: $searchTerm) {
      edges {
        node {
          title
          slug
          content
          image {
            url
          }
          time {
            timestamp
          }
        }
      }
    }
  }
`;

export default SearchPage;
